import { useQuery } from '@tanstack/react-query';
import { DateTime } from 'luxon';

import { getVenueAdCampaignList } from 'apis/ad-bookings/api';

import { CampaignsQueryKeys } from '../../campaignsQueryKeys';

type UseAdsCampaignsCountProps = {
  venueId: string;
  enabled?: boolean;
  startDateAfter?: DateTime;
};

export const useAdsCampaignsCount = ({
  venueId,
  enabled,
  startDateAfter = DateTime.fromISO('2000-01-01'),
}: UseAdsCampaignsCountProps) => {
  const {
    data: adCampaignsList = [],
    isLoading,
    isFetching,
  } = useQuery(
    CampaignsQueryKeys.ADS.VENUES.GET_CAMPAIGN_COUNT(venueId, startDateAfter.toISODate()),
    async () => (await getVenueAdCampaignList(venueId, startDateAfter.toISODate())).results,
    { refetchOnWindowFocus: false, enabled: !!venueId && enabled },
  );

  return {
    campaignsCount: adCampaignsList.length,
    isLoading: isLoading && isFetching,
  };
};
